// @flow
import { viewerFragment, companyManagedFragment } from './index'

export const featureFragment = `
  id
  uid
  title
  description
  image
`

export const roomFragment = `
  id
  name
  pageTitle
  uid
  capacity
  rentalReputationScore
  rentalReputationCount
  prices {
    minText
    minUnitText
    maxText
    maxUnitText
  }
  thumbnails(page: 1, perPage: 5) {
    results {
      id
      url
      description
    }
  }
  space {
    username
    access
    postalCode
    state
    stateText
    city
    address1
    address2
    latitude
    longitude
  }
  isFavorite
  hasDirectReservationPlans
  owner {
    id
    rank
  }
`

export const spaceRoomFragment = `
  id
  name
  pageTitle
  uid
  capacity
  reputationSummary {
    score
    count
  }
  prices {
    minText
    minUnitText
    maxText
    maxUnitText
  }
  thumbnails(page: 1, perPage: 5) {
    results {
      id
      url
      description
    }
  }
  space {
    username
    access
    state
    stateText
    city
    address1
    address2
  }
  isFavorite
  hasDirectReservationPlans
  owner {
    id
    rank
  }
  sponsoredPromotions {
    results {
      id
      brandName
      link
    }
  }
`

export const searchRoomFragment = `
  id
  uid
  name
  pageTitle
  uid
  directReservationAccepted
  capacity
  reputationSummary {
    score
    count
  }
  prices {
    minText
    minUnitText
    maxText
    maxUnitText
  }
  thumbnails(page: 1, perPage: 5) {
    results {
      id
      url
      description
    }
  }
  isInquiryOnly
  space {
    username
    access
    postalCode
    state
    stateText
    city
    address1
    address2
    latitude
    longitude
  }
  isFavorite
  sponsoredPromotions {
    results {
      id
      brandName
      link
    }
  }
`

export const roomsFragment = `
  results {
    ${roomFragment}
  }
`

export const searchRoomsFragment = `
  results {
    ${searchRoomFragment}
  }
`

export const ownerFragment = `
  id
  name
  corpName
  rank
  profile
  profileImage
  username
  createdAt
  confirmRate
  confirmRateEvaluation
  confirmRateText
  replyRate
  replyRateEvaluation
  replyRateText
  replyTimeAvg
  replyTimeAvgEvaluation
  replyTimeAvgText
  isVerifiedEmail
  isVerifiedTel
  isAvailableJcbCards
`

export const guideArticleFragment = `
  id
  slug
  title
  image
  category {
    id
    slug
    breadcrumbs {
      id
      title
      slug
    }
  }
  publishedAtText(format: "default")
  author {
    name
    title
  }
`

export const pageInfoFragment = `
pageInfo {
  resultsCount
  totalCount
  currentPage
  totalPages
  hasNextPage
  nextPage
  hasPreviousPage
  previousPage
}
`

export const searchMasterFragment = `
amenities(rentType: DAY_TIME) {
  results {
    id
    name
    nameText
  }
}
eventTypes(rentType: DAY_TIME) {
  results {
    name
    nameText
  }
}
capacities {
  results {
    number
  }
}
sponsoredPromotions {
  results {
    id
    name
  }
}
`

export const headerFragment = `
promotions(page: 1) {
  results {
    backgroundColor
    backgroundImage
    endedAt
    id
    linkColor
    textColor
    title
  }
}
viewer {
  ${viewerFragment}
  owners {
    results {
      ... on Owner {
        ${ownerFragment}
      }
    }
  }
  isCorp
  companies(filter: MANAGED) {
    results{
      ... on Company {
        ${companyManagedFragment}
      }
    }
  }
}
`
export const paymentHeaderFragment = `
promotions(page: 1) {
  results {
    backgroundColor
    backgroundImage
    endedAt
    id
    linkColor
    textColor
    title
  }
}
viewer {
  ${viewerFragment}
  allCompanies: companies(filter: ALL) {
    results{
      ... on Company {
        ${companyManagedFragment}
      }
    }
  }
  owners {
    results {
      ... on Owner {
        ${ownerFragment}
      }
    }
  }
  isCorp
  companies(filter: MANAGED) {
    results{
      ... on Company {
        ${companyManagedFragment}
      }
    }
  }
}
`

export const notificationFragment = `
results {
  id
  content
  notificationType
  link
  readAt
  fromType
  from {
    ... on User {
      contactName
    }
    ... on Owner {
      ownerName
    }
    ... on ServiceAdmin {
    }
    ... on AdminUser {
    }
  }
  aboutType
  about {
    ... on Reservation {
      uid
      user {
        id
      }
      owner{
        username
      }
    }
    ... on Owner {
      username
    }
    ... on Point {
    }
  }
  createdAtDateTimeText(format: "short")
}
`



// WEBPACK FOOTER //
// ./src/common/fragments/www.js